import React, { Component } from "react";
import queryString from "query-string";
import validator from "validator";
import api from "../../../utils/api";
import Header from "../../ui/header/header";
import { Form } from "semantic-ui-react";
import { PrimaryButton } from "../../ui/button/button";
import { Title } from "../../ui/typography/typography";
import { TextInput, MultilineInput } from "../../ui/inputs/inputs";
import MediaCarousel from "../../ui/mediaCarousel/mediaCarousel";
import { MediaContainer } from "../../ui/mediaContainer/mediaContainer";
import { ErrorAlert } from "../../ui/alert/alert";
import "../../ui/base/base.css";
import styles from "./createBookmarkPage.css";

class EditUrlDataPage extends Component {
	constructor() {
		super();

		this.state = {
			title: "",
			selectedImage: null,
			description: "",
			images: [],
			tags: [],
			location: {},
			data: [],
			url: "",
			isLoading: false,
			hasContentOrSource: false
		};

		this.onSubmit = this.onSubmit.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onKeyPress = this.onKeyPress.bind(this);
		this.noSelectedImage = this.noSelectedImage.bind(this);
		this.previewUploadedFile = this.previewUploadedFile.bind(this);
		this.generateScreenshot = this.generateScreenshot.bind(this);
	}

	componentDidMount() {
		this.fetchData();
	}

	onChange(e) {
		this.setState({
			...this.state,
			[e.target.name]: e.target.value
		});
	}

	onKeyPress(e) {
		// Check if Url field has value and enter key is pressed
		if (this.state.url !== "" && e.key === "Enter") {
			const { url } = this.state;
			const isUrl = validator.isURL(url);
			const encodedUrl = encodeURIComponent(url);

			if (isUrl) {
				this.props.history.push(`/bookmark/create?url=${encodedUrl}`);
				this.setState({ error: null }, this.fetchData);
			} else {
				this.setState({
					error: "Please use a valid url",
					hasContentOrSource: false
				});
			}
		}
	}

	onClick(selectedImage) {
		this.setState({ selectedImage });
	}

	async onSubmit(e) {
		const { data } = await api.bookmark.create(this.state); // Create bookmark
		api.bookmark.uploadToS3(this.state.selectedImage, data.id); // Upload image in background
		this.props.history.push("/");
	}

	async fetchData() {
		const reqUrl = queryString.parse(this.props.location.search).url; // Parse out url from params

		if (!reqUrl) return;

		this.setState({ isLoading: true, hasContentOrSource: true });

		await api.bookmark
			.getUrlData(reqUrl)
			.then(res => {
				const { title, images, url, description, location, data } = res;

				this.setState({
					title,
					images,
					url,
					description,
					location,
					data,
					isLoading: false,
					selectedImage: images ? images[0] : null,
					hasContentOrSource: true
				});

				// If no images were found on page generate screenshot
				if (!this.state.images.length) this.generateScreenshot();
			})
			.catch(err => {
				this.setState({
					error: err.response.data.error,
					isLoading: false,
					hasContentOrSource: false
				});
			});
	}

	async generateScreenshot() {
		this.setState({ generatingScreenshot: true });

		const { screenshot } = await api.bookmark.generateScreenshot(
			this.state.url
		);

		this.setState({
			generatingScreenshot: undefined,
			images: [screenshot, ...this.state.images],
			selectedImage: screenshot
		});
	}

	noSelectedImage() {
		// Update state right away stackoverflow.com/questions/30782948
		this.setState({ selectedImage: null }, function() {
			console.log(this.state.value);
		});
	}

	previewUploadedFile(event) {
		const file = event.target.files[0];
		const previewOfUploadedFile = URL.createObjectURL(file);

		this.setState({
			title: file.name,
			file: previewOfUploadedFile,
			selectedImage: previewOfUploadedFile,
			hasContentOrSource: true
		});
	}

	render() {
		const {
			title,
			images,
			url,
			description,
			selectedImage,
			error,
			isLoading,
			generatingScreenshot,
			hasContentOrSource
		} = this.state;

		return (
			<div>
				<Header history={this.props.history} />
				<Title className={styles.title}>Create bookmark</Title>
				{error && <ErrorAlert>{error}</ErrorAlert>}

				<Form className={styles.container} onSubmit={this.onSubmit}>
					<div className={styles.mediaContainer}>
						{!hasContentOrSource && (
							<TextInput
								type="text"
								id="url"
								name="url"
								placeholder="Enter url to bookmark"
								value={url}
								onChange={this.onChange}
								onKeyPress={this.onKeyPress}
							/>
						)}

						<MediaContainer
							className={styles.mediaPrimary}
							image={selectedImage}
						>
							<input
								type="file"
								onChange={this.previewUploadedFile}
								disabled={hasContentOrSource}
							/>

							{(!hasContentOrSource || isLoading) && (
								<div
									className={`${styles.mediaPrimaryMessage} ${
										isLoading ? styles.mediaPrimaryMessageLoading : null
									}`}
								>
									{isLoading
										? "Fetching information"
										: "Drag and drop or click to upload"}
								</div>
							)}
						</MediaContainer>

						<MediaCarousel
							images={images}
							onClick={this.onClick.bind(this)}
							selectedImage={selectedImage}
						>
							<div className={styles.imageChooser}>
								<button
									className={styles.imageChooserButton}
									onClick={this.generateScreenshot}
									type="button"
								>
									{generatingScreenshot
										? "Taking screenshot"
										: "Take screenshot"}
								</button>
								<hr />
								<button
									className={styles.imageChooserButton}
									onClick={this.noSelectedImage}
									type="button"
								>
									No image
								</button>
							</div>
						</MediaCarousel>
					</div>

					<div className={styles.infoContainer}>
						<TextInput
							placeholder="Title"
							name="title"
							value={title}
							onChange={this.onChange}
							disabled={!hasContentOrSource || isLoading}
						/>
						<TextInput
							placeholder="Url"
							name="url"
							value={url}
							onChange={this.onChange}
							disabled={!hasContentOrSource || isLoading}
						/>
						<TextInput
							placeholder="Tags"
							name="tags"
							onChange={this.onChange}
							disabled={!hasContentOrSource}
						/>
						<MultilineInput
							placeholder="Description"
							name="description"
							value={description}
							onChange={this.onChange}
							disabled={!hasContentOrSource || isLoading}
						/>

						<PrimaryButton
							className={styles.button}
							disabled={!hasContentOrSource || isLoading}
						>
							Create bookmark
						</PrimaryButton>
					</div>
				</Form>
			</div>
		);
	}
}

export default EditUrlDataPage;



// WEBPACK FOOTER //
// ./src/components/pages/createBookmarkPage/createBookmarkPage.js